<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">
          （<span>{{ regulations.time }}</span>
          数据来源：国家文物局博物馆与社会文物司）
        </p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入机构名称/法定代表人/地址"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div class="dat">
          <div class="paging">
            <el-select
              v-model="province"
              clearable
              placeholder="省份"
              class="province"
              @change="provinceChange()"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="batch"
              clearable
              placeholder="批次"
              class="batch"
              @clear="runClear"
              @change="batchChange()"
            >
              <el-option
                v-for="item in batchList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              :index="count"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="organizationName"
              label="机构名称"
              min-width="160px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="legalRepresentative"
              label="法定代表人"
              min-width="120px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="proName"
              label="省份"
              min-width="110px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="address"
              label="地址"
              min-width="160px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="zipCode"
              label="邮编"
              min-width="120px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="telNo"
              label="电话"
              min-width="160px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="pubName"
              label="批次"
              min-width="160px"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  URL_EVALUATION_INSTITUTIONS,
  URL_COMPREHENSIVE_EXCUSE,
  URL_DESCRIPTION_FIND,
} from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "涉案文物鉴定评估机构名单",
        // 浏览次数
        num: "2",
        // 更新时间
        time: null,
      },
      // 省份
      provinceList: [],
      // 省份
      province: null,
      // 批次
      batchList: [],
      // 批次
      batch: null,
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      // 前往页数
      currentPage: 1,
      // 总条数
      total: 100,
      pagesize: 20,
    };
  },
  computed: {},
  methods: {
    // 请求列表数据
    getList() {
      let result = frontHeater(
        ["districtCode", "batchNum"],
        [this.province, this.batch]
      );
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pagesize,
        keywords: this.searchOn,
        districtCode: this.province,
        batchNum: this.batch,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["districtCode"] = this.province;
      this.$http.defaults.headers.common["batchNum"] = this.batch;
      this.$http
        .get(Url + URL_EVALUATION_INSTITUTIONS, { params })
        .then((res) => {
          if (res.status == 200) {
            this.legalForms = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    //获取省份
    getProvinceList() {
      let result = frontHeater(["ClassCode"], ["DistrictCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "DistrictCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "DistrictCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.provinceList = res.data.data;
        }
      });
    },
    //获取批次
    getBatchList() {
      let result = frontHeater(["ClassCode"], ["InvolvedAppraisalBatchNum"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "InvolvedAppraisalBatchNum",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] =
        "InvolvedAppraisalBatchNum";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.batchList = res.data.data;
        }
      });
    },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataInvolvedAppraisal"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataInvolvedAppraisal",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] = "DataInvolvedAppraisal";
      this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
        }
      });
    },
    runClear() {
      this.searchOn = null;
      this.province = null;
      this.batch = null;
      this.getList();
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.province = null;
      this.batch = null;
      this.currentPage = 1;
      this.getList();
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 表格分页
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    provinceChange() {
      this.getList();
    },
    batchChange() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
    this.getProvinceList();
    this.getBatchList();
    this.getNumberViews();
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
@import "../../../styles/Hierarchy";
.tlt1 {
  font-size: 22px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 14px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}
.province {
  width: 170px;
}
.batch {
  width: 150px;
}
.dat {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 10px 0;
  align-items: center;
}
</style>
